import React from 'react';
import Header from '../components/Header';
import InformationsGenerales from './InformationsGenerales';
import CriteresReussite from './CriteresReussite';
import Footer from '../components/Footer';
import useSEO from '../components/SEO';

const FormationsPage: React.FC = () => {
    useSEO({
        title: "Formations - ISTMECH",
        description: "Informations générales, organisation des études et critères de réussite des formations en technologie médicale à l'ISTMECH.",
        keywords: "ISTMECH, formations, informations générales, critères de réussite, études",
        url: "https://www.istmech.edu.ht/formations",
        image: "https://www.istmech.edu.ht/og-image.png"
    });

    return (
        <div className="App">
            <Header />
            <main className="pt-20">
                <InformationsGenerales />
                <CriteresReussite />
            </main>
            <Footer />
        </div>
    );
};

export default FormationsPage;
